import {PropsWithChildren} from "react";
import {Box} from "@mui/material";

export default function Page({ children }: PropsWithChildren) {
  return (
    <Box p={4} maxWidth={1200} mx="auto">
      <section>{children}</section>
    </Box>
  )
}